// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './FishFinderBuilder.css';
import LandingPage from './components/LandingPage';
import Parent from './Parent';
import QuickScreenComparison from './components/QuickScreenComparison';
import Summary from './components/Summary';
import SharedLayout from './components/SharedLayout';
import FishFinderBuilder from './components/FishFinderBuilder';
import SelectionFlow from './components/SelectionFlow';
import AskQuestion from './components/AskQuestion';
import QuickBundles from './components/QuickBundles';
import SimpleLiveScopePlusLVS34 from './components/PriceComparison/SimpleLiveScopePlusLVS34';
import SimpleLiveScopeXRLVS62 from './components/PriceComparison/SimpleLiveScopeXRLVS62';
import SimplePanoptixPS22 from './components/SimplePanoptixPS22';
import SimplePanoptixPS30 from './components/SimplePanoptixPS30';
import SimpleGT54UHD from './components/SimpleGT54UHD';
import SimpleGT56UHD from './components/SimpleGT56UHD';
import SimpleGT10HNIF from './components/SimpleGT10HNIF';
import SimpleGT8HWIF from './components/SimpleGT8HWIF';
import SimpleAmpedOutdoors30AhLiFePO4With3ACharger from './components/SimpleAmpedOutdoors30AhLiFePO4With3ACharger';
import SimpleAmpedOutdoors30AhLiFePO4BatteryOnly from './components/SimpleAmpedOutdoors30AhLiFePO4BatteryOnly';
import SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth from './components/SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth';
import SimpleAmpedOutdoors8AhLiFePO4BatteryOnly from './components/SimpleAmpedOutdoors8AhLiFePO4BatteryOnly';
import SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger from './components/SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger';
import SimpleAmped15AhLifePO4 from './components/SimpleAmped15AhLifePO4';
import SimpleAmped15AhLifePO4WithCharger from './components/SimpleAmped15AhLifePO4WithCharger';
import SimpleAmped19AhNMCWithCharger from './components/SimpleAmped19AhNMCWithCharger';
import SimpleAmped20AhLifePO4 from './components/SimpleAmped20AhLifePO4';
import SimpleAmped20AhLifePO4WithCharger from './components/SimpleAmped20AhLifePO4WithCharger';
import SimpleAmped52AhNMCBluetoothWithCharger from './components/SimpleAmped52AhNMCBluetoothWithCharger';
import SimpleHDIShuttle from './components/SimpleHDIShuttle';
import SimpleHDIShuttleDIYKit from './components/SimpleHDIShuttleDIYKit';
import SimpleUltra2106svLVS34Bundle from './components/SimpleUltra2106svLVS34Bundle';
import SimpleUltra2126svLVS34Bundle from './components/SimpleUltra2126svLVS34Bundle';
import SummitFishingShuttle from './components/SummitFishingShuttle';
import BreakAwayPoleTrackAllTerrain from './components/BreakAwayPoleTrackAllTerrain';
import BreakawayPoleFlatAllTerrain from './components/BreakawayPoleFlatAllTerrain';
import BreakawayPoleFlatOriginal from './components/BreakawayPoleFlatOriginal';

import FixedPoleFlatAllTerrain from './components/FixedPoleFlatAllTerrain';
import FixedPoleFlatOriginal from './components/FixedPoleFlatOriginal';
import HdiCarbon1836Lvs34 from './components/HdiCarbon1836Lvs34';
import HdiCarbon2460Lvs34 from './components/HdiCarbon2460Lvs34';
import HdiCarbon3280Lvs34 from './components/HdiCarbon3280Lvs34';
import HdiCarbon1836Lvs32 from './components/HdiCarbon1836Lvs32';
import HdiCarbon2460Lvs32 from './components/HdiCarbon2460Lvs32';
import HdiCarbon3280Lvs32 from './components/HdiCarbon3280Lvs32';
import GarminEchomapUhd273sv from './components/PriceComparison/GarminEchomapUhd273sv';
import GarminEchomapUhd293sv from './components/PriceComparison/GarminEchomapUhd293sv';
import GarminEchomapUltra2106sv from './components/PriceComparison/GarminEchomapUltra2106sv';
import GarminEchomapUltra2126sv from './components/PriceComparison/GarminEchomapUltra2126sv';
import GarminGpsmap8610xsv from './components/PriceComparison/GarminGpsmap8610xsv';
import GarminGpsmap8612xsv from './components/PriceComparison/GarminGpsmap8612xsv';
import GarminGpsmap943xsv from './components/PriceComparison/GarminGpsmap943xsv';
import GarminGpsmap1243xsv from './components/PriceComparison/GarminGpsmap1243xsv';
import GarminGpsmap1042xsv from './components/PriceComparison/GarminGpsmap1042xsv';
import GarminGpsmap1242xsv from './components/PriceComparison/GarminGpsmap1242xsv';
import SimpleProductPage from './components/PriceComparison/SimpleProductPage';
import ProductComparisonPage from './components/PriceComparison/ProductComparisonPage';
import ProductPriceComparison from './components/PriceComparison/ProductPriceComparison';
import PriceComparisonLanding from './components/PriceComparison/PriceComparisonLanding';
import { ThemeProvider } from './context/ThemeContext';
import SimplePriceComparison from './components/PriceComparison/SimplePriceComparison';
import ContactPage from './components/ContactPage';
import LinkListPage from './components/LinkListPage';
import LinkListPageOrganized from './components/LinkListPageOrganized';
import RouteTracker from './components/RouteTracker';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <RouteTracker />
        <Routes>
          <Route element={<SharedLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/BuildMyFishFinder/*" element={<Parent />} />
            <Route path="/custom-builder" element={<FishFinderBuilder />} />
            <Route path="/quick-bundles" element={<QuickBundles />} />
            <Route path="/compare-screens" element={<QuickScreenComparison />} />
            <Route path="/price-comparison" element={<PriceComparisonLanding />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/select/:componentType" element={<SelectionFlow />} />
            <Route path="/ask-question" element={<AskQuestion />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blackfriday2025deals" element={<LinkListPage />} />
            <Route path="/bftest" element={<LinkListPageOrganized />} />
            <Route path="/simple-products/Ultra2 106sv + LVS34 Bundle" element={<SimpleUltra2106svLVS34Bundle />} />
            <Route path="/simple-products/Ultra2 126sv + LVS34 Bundle" element={<SimpleUltra2126svLVS34Bundle />} />
            <Route path="/simple-products/livescope-plus-lvs34" element={<SimpleLiveScopePlusLVS34 />} />
            <Route path="/simple-products/livescope-xr-lvs62" element={<SimpleLiveScopeXRLVS62 />} />
            <Route path="/simple-products/panoptix-ps22" element={<SimplePanoptixPS22 />} />
            <Route path="/simple-products/panoptix-ps30-down" element={<SimplePanoptixPS30 />} />
            <Route path="/simple-products/gt54uhd-chirp" element={<SimpleGT54UHD />} />
            <Route path="/simple-products/gt56uhd-chirp" element={<SimpleGT56UHD />} />
            <Route path="/simple-products/gt10hn-if" element={<SimpleGT10HNIF />} />
            <Route path="/simple-products/gt8hw-if" element={<SimpleGT8HWIF />} />
            <Route path="/simple-products/amped-30ah-lifepo4-with-charger" element={<SimpleAmpedOutdoors30AhLiFePO4With3ACharger />} />
            <Route path="/simple-products/amped-30ah-lifepo4" element={<SimpleAmpedOutdoors30AhLiFePO4BatteryOnly />} />
            <Route path="/simple-products/amped-32ah-nmc-with-charger" element={<SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth />} />
            <Route path="/simple-products/amped-8ah-lifepo4" element={<SimpleAmpedOutdoors8AhLiFePO4BatteryOnly />} />
            <Route path="/simple-products/amped-8ah-lifepo4-with-charger" element={<SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger />} />
            <Route path="/simple-products/amped-15ah-lifepo4" element={<SimpleAmped15AhLifePO4 />} />
            <Route path="/simple-products/amped-15ah-lifepo4-with-charger" element={<SimpleAmped15AhLifePO4WithCharger />} />
            <Route path="/simple-products/amped-19ah-nmc-with-charger" element={<SimpleAmped19AhNMCWithCharger />} />
            <Route path="/simple-products/amped-20ah-lifepo4" element={<SimpleAmped20AhLifePO4 />} />
            <Route path="/simple-products/amped-20ah-lifepo4-with-charger" element={<SimpleAmped20AhLifePO4WithCharger />} />
            <Route path="/simple-products/amped-52ah-nmc-bluetooth-with-charger" element={<SimpleAmped52AhNMCBluetoothWithCharger />} />
                      <Route path="/simple-products/breakaway-pole-track-all-terrain" element={<BreakAwayPoleTrackAllTerrain />} />
          <Route path="/simple-products/breakaway-pole-flat-all-terrain" element={<BreakawayPoleFlatAllTerrain />} />
          <Route path="/simple-products/breakaway-pole-flat-original" element={<BreakawayPoleFlatOriginal />} />

          <Route path="/simple-products/fixed-pole-flat-all-terrain" element={<FixedPoleFlatAllTerrain />} />
          <Route path="/simple-products/fixed-pole-flat-original" element={<FixedPoleFlatOriginal />} />
          <Route path="/simple-products/hdi-carbon-18-36-lvs34" element={<HdiCarbon1836Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-18-36-lvs32" element={<HdiCarbon1836Lvs32 />} />
          <Route path="/simple-products/hdi-carbon-24-60-lvs34" element={<HdiCarbon2460Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-24-60-lvs32" element={<HdiCarbon2460Lvs32 />} />
          <Route path="/simple-products/hdi-carbon-32-80-lvs34" element={<HdiCarbon3280Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-32-80-lvs32" element={<HdiCarbon3280Lvs32 />} />
                    <Route path="/simple-products/hdi-shuttle" element={<SimpleHDIShuttle />} />
        <Route path="/simple-products/hdi-shuttle-diy-kit" element={<SimpleHDIShuttleDIYKit />} />
        <Route path="/simple-products/summit-fishing-shuttle" element={<SummitFishingShuttle />} />
        <Route path="/simple-products/echomap-73sv-uhd2" element={<GarminEchomapUhd273sv />} />
            <Route path="/simple-products/echomap-93sv-uhd2" element={<GarminEchomapUhd293sv />} />
            <Route path="/simple-products/echomap-ultra-2-106sv" element={<GarminEchomapUltra2106sv />} />
            <Route path="/simple-products/echomap-ultra-2-126sv" element={<GarminEchomapUltra2126sv />} />
            <Route path="/simple-products/gpsmap-8610xsv" element={<GarminGpsmap8610xsv />} />
            <Route path="/simple-products/gpsmap-8612xsv" element={<GarminGpsmap8612xsv />} />
            <Route path="/simple-products/gpsmap-943xsv" element={<GarminGpsmap943xsv />} />
            <Route path="/simple-products/gpsmap-1243xsv" element={<GarminGpsmap1243xsv />} />
            <Route path="/simple-products/gpsmap-1042xsv" element={<GarminGpsmap1042xsv />} />
            <Route path="/simple-products/gpsmap-1242xsv" element={<GarminGpsmap1242xsv />} />
            <Route path="/simple-products/db/:slug" element={<ProductComparisonPage />} />
            <Route path="/simple-products/:productId" element={<SimpleProductPage />} />
            <Route path="/compare/:productIds" element={<SimplePriceComparison />} />
            <Route path="/products/:productId" element={<ProductPriceComparison />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
